export default "__VITE_ASSET__7241ada8__"